import { Box, Button } from '@material-ui/core';
import clsx from 'clsx';
import { ReactNode, MouseEvent, CSSProperties } from 'react';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { useCustomSelectButtonStyles } from './style';
import SText, { STextProps } from '../../../../sui/stext';
import { TextColor } from '../../../../../enums';

export interface SSelectDetailsButtonProps {
  width?: number | string;
  title?: string;
  titleHighligted?: boolean;
  label?: string;
  icon?: ReactNode;
  open?: boolean;
  noBorder?: boolean;
  style?: CSSProperties;
  fontWeight?: STextProps['weight'];
  fontSize?: string;
  // ! This sloud be removed when we migrate whole app new design
  newDesign?: boolean;
  fontColor?: TextColor | string;
  renderTitle?: (title: string) => JSX.Element;

  onClick?: (event: MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  error?: string;
}

const SSelectDetailsButton = ({
  title,
  titleHighligted,
  renderTitle,
  open,
  icon,
  label,
  onClick,
  width,
  noBorder = true,
  style,
  disabled = false,
  error,
  fontWeight,
  fontSize,
  newDesign,
  fontColor = TextColor.Grey
}: SSelectDetailsButtonProps) => {
  const classes = useCustomSelectButtonStyles({
    newDesign,
    open,
    width,
    noBorder
  });

  return (
    <Box>
      <Button
        className={classes.container}
        onClick={onClick}
        style={style}
        disabled={disabled}>
        <Box
          className={classes.valueWrapper}
          display="flex"
          alignItems="center">
          {label && (
            <SText
              title={`${label} :`}
              style={{
                fontSize
              }}
            />
          )}
          {renderTitle ? (
            renderTitle(title)
          ) : (
            <SText
              maxLines={1}
              title={title}
              fontColor={fontColor}
              style={{
                lineHeight: 'normal',
                fontWeight: fontWeight || '',
                fontSize
              }}
              className={clsx({
                [classes.labelDetails]: true,
                [classes.labelHighlight]: titleHighligted
              })}
            />
          )}
        </Box>
        <Box className={classes.iconContainer}>
          {icon || <ArrowForwardIosIcon style={{ fontSize: 16 }} />}
        </Box>
      </Button>
      {error && (
        <SText
          style={{ marginTop: '7px', fontWeight: 500 }}
          color="error"
          size="sm"
          title={error}
        />
      )}
    </Box>
  );
};

export default SSelectDetailsButton;
